// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const $ = require('jquery');
const Browser = require('@trello/browser');
const Footer = require('app/scripts/views/footer');
const Auth = require('app/scripts/db/auth');
const { getQueryParameter } = require('app/scripts/lib/util');
const {
  currentModelManager,
} = require('app/scripts/controller/currentModelManager');

module.exports = {
  maybeShowFooterChrome(url) {
    const $el = $('#footer-chrome');
    $el.hide();

    if (Browser.isEmbeddedDocument() && currentModelManager.onAnyBoardView()) {
      $el.show();
      const footerView = new Footer({
        url,
        shouldDisplayLogout() {
          return (
            getQueryParameter('iframeSource', '') === 'msteams' &&
            Auth.isLoggedIn()
          );
        },
        getLogoutReturnUrl() {
          if (getQueryParameter('iframeSource', '') === 'msteams') {
            return `/integrations/teams/tab-content?iframeSource=msteams&contentUrl=${encodeURIComponent(
              url,
            )}`;
          }
        },
      });
      return $el.html(footerView.render().el);
    }
  },
};
